export const CLEAR_STATUS = 'ui/CLEAR_STATUS'
